<template>
  <div v-if="!isFetchingAppIntegrations">
    <div v-if="isSangomaAIIntegrationEnabled" class="relative">
      <SangomaAIAssistanceCTAButton
        v-if="shouldShowAIAssistCTAButton"
        @click="openAIAssist"
      />
      <woot-button
        v-else
        v-tooltip.top-end="$t('INTEGRATION_SETTINGS.SANGOMA_AI.AI_ASSIST')"
        icon="bot"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        @click="openAIAssist"
      />
      <woot-modal
        :show.sync="showSangomaAIAssistanceModal"
        :on-close="hideAIAssistanceModal"
      >
        <SangomaAIAssistanceModal
          :ai-option="aiOption"
          @apply-text="insertText"
          @close="hideAIAssistanceModal"
        />
      </woot-modal>
    </div>
    <div v-else-if="shouldShowAIAssistCTAButtonForAdmin" class="relative">
      <SangomaAIAssistanceCTAButton @click="openAICta" />
      <woot-modal :show.sync="showSangomaAICtaModal" :on-close="hideAICtaModal">
        <SangomaAICTAModal @close="hideAICtaModal" />
      </woot-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SangomaAICTAModal from './SangomaAICTAModal.vue';
import SangomaAIAssistanceModal from './SangomaAIAssistanceModal.vue';
import adminMixin from 'dashboard/mixins/isAdmin';
import sangomaAiMixin from 'dashboard/mixins/sangomaAiMixin';
import { CMD_SANGOMA_AI_ASSIST } from 'dashboard/routes/dashboard/commands/commandBarBusEvents';
import eventListenerMixins from 'shared/mixins/eventListenerMixins';
import { buildHotKeys } from 'shared/helpers/KeyboardHelpers';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import SangomaAIAssistanceCTAButton from './SangomaAIAssistanceCTAButton.vue';

export default {
  components: {
    SangomaAIAssistanceModal,
    SangomaAICTAModal,
    SangomaAIAssistanceCTAButton,
  },
  mixins: [sangomaAiMixin, eventListenerMixins, adminMixin, uiSettingsMixin],
  data: () => ({
    showSangomaAIAssistanceModal: false,
    showSangomaAICtaModal: false,
    aiOption: '',
    initialMessage: '',
  }),
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      isAChatwootInstance: 'globalConfig/isAChatwootInstance',
    }),
    isSangomaAICTAModalDismissed() {
      return this.uiSettings.is_sangoma_ai_cta_modal_dismissed;
    },
    // Display a AI CTA button for admins if the AI integration has not been added yet and the AI assistance modal has not been dismissed.
    shouldShowAIAssistCTAButtonForAdmin() {
      return (
        this.isAdmin &&
        !this.isSangomaAIIntegrationEnabled &&
        !this.isSangomaAICTAModalDismissed &&
        this.isAChatwootInstance
      );
    },
    // Display a AI CTA button for agents and other admins who have not yet opened the AI assistance modal.
    shouldShowAIAssistCTAButton() {
      return this.isSangomaAIIntegrationEnabled && !this.isSangomaAICTAModalDismissed;
    },
  },

  mounted() {
    bus.$on(CMD_SANGOMA_AI_ASSIST, this.onAIAssist);
    this.initialMessage = this.draftMessage;
  },

  methods: {
    onKeyDownHandler(event) {
      const keyPattern = buildHotKeys(event);
      const shouldRevertTheContent =
        ['meta+z', 'ctrl+z'].includes(keyPattern) && !!this.initialMessage;
      if (shouldRevertTheContent) {
        this.$emit('replace-text', this.initialMessage);
        this.initialMessage = '';
      }
    },
    hideAIAssistanceModal() {
      this.recordAnalytics('DISMISS_AI_SUGGESTION', {
        aiOption: this.aiOption,
      });
      this.showSangomaAIAssistanceModal = false;
    },
    openAIAssist() {
      // Dismiss the CTA modal if it is not dismissed
      if (!this.isSangomaAICTAModalDismissed) {
        this.updateUISettings({
          is_sangoma_ai_cta_modal_dismissed: true,
        });
      }
      this.initialMessage = this.draftMessage;
      const ninja = document.querySelector('ninja-keys');
      ninja.open({ parent: 'sangoma_ai_assist' });
    },
    hideAICtaModal() {
      this.showSangomaAICtaModal = false;
    },
    openAICta() {
      this.showSangomaAICtaModal = true;
    },
    onAIAssist(option) {
      this.aiOption = option;
      this.showSangomaAIAssistanceModal = true;
    },
    insertText(message) {
      this.$emit('replace-text', message);
    },
  },
};
</script>
